import { render, staticRenderFns } from "./MuseumStories.vue?vue&type=template&id=33240046&"
import script from "./MuseumStories.vue?vue&type=script&lang=js&"
export * from "./MuseumStories.vue?vue&type=script&lang=js&"
import style0 from "./MuseumStories.vue?vue&type=style&index=0&id=33240046&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports